<script>
import {
  ArrowUpIcon,
  ChevronRightIcon,
  UserIcon,
  MailIcon,
  MessageCircleIcon,
  PlayIcon,
  VideoIcon
} from "vue-feather-icons";
import { Carousel, Slide } from "vue-carousel";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import Footer from "@/components/footer";
import Features from "@/components/features";

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

const axios = require('axios').default;


/**
 * Index-hotel component
 */
export default {
  props: ['testProp'],
  data() {
    return {
      slide: 0,
      date: new Date(),
      checkoutdate: new Date(Date.now() + 3600 * 1000 * 24),
      hotels : {},
      isCondensed: false,
      testimonialData: {},
      response: true,
      hotelImage: {},
      isLoading: true,
      fullPage: true
    };
  },
  components: {
    Footer,
    Carousel,
    Slide,
    ArrowUpIcon,
    ChevronRightIcon,
    UserIcon,
    MailIcon,
    VideoIcon,
    MessageCircleIcon,
    PlayIcon,
    flatPickr,
    Features,
    Loading
  },
  created: function() {
    this.getHotels();
  
  },
  methods: {
    showModal(images, id) {
      console.log(id)
      this.testimonialData = images;
      this.hotelImage.image = this.testimonialData[0];
      this.hotelImage.index = 0;
      this.hotelID = id;
      console.log(this.hotelImage)
      document.getElementById("myBtn").click();
      // let slideIndex = 1;
      // this.showSlides(slideIndex);
    },
    book(id) {
      // console.log(id)
      this.hotelID = id;
      this.$router.push({ name: "Booking", params: { key: this.hotelID, hotels: this.hotels}});
    },
    toggleMenu() {
      this.isCondensed = !this.isCondensed;
      if (this.isCondensed) {
        document.getElementById("navigation").style.display = "block";
      } else document.getElementById("navigation").style.display = "none";
    },
    getHotels() {
      let self = this;
      axios.get('https://app.quarantinefacility.ph/api/get_hotel')
      .then(function (response) {
        self.hotels = response.data
        setTimeout(() => {
            self.isLoading = false
        },1000);
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    openModal() {
      const modal = document.getElementById("myModal");
      modal.style.display = "block";
    },
    closeModal() {
      const modal = document.getElementById("myModal");
      modal.style.display = "none";
    },
    // Next/previous controls
    plusSlides(n) {
      let slideIndex = 1;
      this.showSlides(slideIndex += n);
    },
    // Thumbnail image controls
    currentSlide(n) {
      let slideIndex = 1;
      this.showSlides(slideIndex = n);
    },
    showSlides(n) {
      let i;
      let slideIndex = 1;
      const slides = document.getElementsByClassName("mySlides");
      console.log(slides[0].style, "style");
      const dots = document.getElementsByClassName("dot");
      console.log(dots);

      if (n > slides.length) {slideIndex = 1}
      if (n < 1) {slideIndex = slides.length}
      for (i = 0; i < slides.length; i++) {
          slides[i].style.display = "none";
      }
      for (i = 0; i < dots.length; i++) {
          dots[i].className = dots[i].className.replace(" active", "");
      }
      slides[slideIndex-1].style.display = "block";
      dots[slideIndex-1].className += " active";
    },
    leftShow () {
      console.log(left)
      if(this.hotelImage.index == 0){
        this.hotelImage.index = 2;
        this.hotelImage.image = this.testimonialData[2];
      } else {
        this.hotelImage.index = this.hotelImage.index - 1;
        this.hotelImage.image = this.testimonialData[this.hotelImage.index - 1];
      }
    },
    rightShow () {
      console.log(right)
      if(this.hotelImage.index == 2){
        this.hotelImage.index = 0;
        this.hotelImage.image = this.testimonialData[0];
      } else {
        this.hotelImage.index = this.hotelImage.index + 1;
        this.hotelImage.image = this.testimonialData[this.hotelImage.index + 1];
      }
    }
  }
};
</script>

<template>
  <div>
    <header id="topnav" class="defaultscroll sticky" style = "background-color: white;">
      <div class="container">
        <!-- Logo container-->
        <div>
          <router-link to="/" class="logo"><img src="images/quarantine_black.png" height="50" alt="" /></router-link>
        </div>
        <div class="buy-button">
          <router-link to="/booking" class="btn btn-primary">Book Now</router-link>
        </div>
        <!--end login button-->
        <!-- End Logo container-->
        <div class="menu-extras">
          <div class="menu-item">
            <!-- Mobile menu toggle-->
            <a
              class="navbar-toggle"
              @click="toggleMenu()"
              :class="{ open: isCondensed === true }"
            >
              <div class="lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </a>
            <!-- End mobile menu toggle-->
          </div>
        </div>

        <div id="navigation">
          <!-- Navigation Menu-->
          <ul
            class="navigation-menu"
            v-scroll-spy-active="{ selector: 'li.has-submenu' }"
          >
            <li class="has-submenu">
              <router-link to="/">Home</router-link>
            </li>
            <li class="has-submenu">
              <router-link to="/">Rooms</router-link>
            </li>
            <li class="has-submenu">
              <router-link to="/">Services</router-link>
            </li>
            <li class="has-submenu">
              <router-link to="/">Contact</router-link>
            </li>
          </ul>
          <!--end navigation menu-->
        </div>
        <!--end navigation-->
      </div>
      <!--end container-->
    </header>

    <loading :active.sync="isLoading" 
        :can-cancel="true"
        :is-full-page="fullPage"></loading>

    <!-- Rooms Start -->
    <section class="section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <h4 class="title mb-4">Our Partner Facilities</h4>

            </div>
          </div>
          <!--end col-->
        </div>

        <!-- Trigger/Open The Modal -->
        <!-- <button v-on:click="openModal" id="myBtn">Open Modal</button> -->

        <!-- The Modal -->
        <!-- <div id="myModal" class="modal">
          <div class="modal-content">
            <div class="modal-header">
              <span v-on:click="closeModal" class="close">&times;</span>
            </div>
            <div class="modal-body">
              <div v-for="(hotel, index) in testimonialData" :key = "index" class="slideshow-container">

                <div class="mySlides fade">
                  <div class="numbertext">1 / 3</div>
                  <img :src="hotel" style="width:100%">
                  <div class="text">Caption Text</div>
                </div>

                <a class="prev" v-on:click="plusSlides(-1)">&#10094;</a>
                <a class="next" v-on:click="plusSlides(1)">&#10095;</a>
              </div>
              <br>

              <div style="text-align:center">
                <span class="dot" v-on:click="currentSlide(1)"></span>
                <span class="dot" v-on:click="currentSlide(2)"></span>
                <span class="dot" v-on:click="currentSlide(3)"></span>
              </div>
              <a v-on:click="leftShow()">&#10094;</a>
              <img :src="this.hotelImage.image" style="width:100%">
              <a v-on:click="rightShow()">&#10095;</a>
            </div>
            <div class="modal-footer">
              <center><h3>Book Now</h3></center>
            </div>
          </div>

        </div> -->

        <div class="row">
          <div v-for="(hotel, index) in hotels" :key = "index"  class="col-lg-4 col-md-6 mt-4 pt-2">
            <div class="quartocard rounded border-0 overflow-hidden">
              <span v-on:click="book(hotel.id)">
                <img
                      :src= hotel.images[0]
                      class="img-fluid rounded"
                      alt="work-image"
                    />
                <div class="quartocard-body p-0">
                  <div class="overlay-work"></div>
                  <div class="content">
                    <a
                      href="javascript:void(0);"
                      class="title text-dark pb-2"
                      >{{ hotel.hotel_name }}</a
                    >
                    <p class="text-dark d-block mb-0">
                      {{ hotel.city }} {{ hotel.region }}
                    </p>
                    <p class="text-dark d-block mb-0">
                      Rent: ₱<span class="text-success">{{ new Intl.NumberFormat('en-US').format(hotel.price)}}</span> /Night
                    </p>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Rooms End -->

    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>


<style scoped>
/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  width: 80%;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s
}

/* Add Animation */
@-webkit-keyframes animatetop {
  from {top:-300px; opacity:0} 
  to {top:0; opacity:1}
}

@keyframes animatetop {
  from {top:-300px; opacity:0}
  to {top:0; opacity:1}
}

/* The Close Button */
.close {
  color: white;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.modal-header {
  padding: 2px 16px;
  background-color: #5cb85c;
  color: white;
}

.modal-body {padding: 2px 16px;}

.modal-footer {
  padding: 2px 16px;
  background-color: #5cb85c;
  color: white;
  text-align: center;
}

* {box-sizing:border-box}

/* Slideshow container */
.slideshow-container {
  max-width: 1000px;
  position: relative;
  margin: auto;
}

/* Hide the images by default */
.mySlides {
  display: none;
}

/* Next & previous buttons */
.prev, .next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  margin-top: -22px;
  padding: 16px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  user-select: none;
}

/* Position the "next button" to the right */
.next {
  right: 0;
  border-radius: 3px 0 0 3px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover, .next:hover {
  background-color: rgba(0,0,0,0.8);
}

/* Caption text */
.text {
  color: #f2f2f2;
  font-size: 15px;
  padding: 8px 12px;
  position: absolute;
  bottom: 8px;
  width: 100%;
  text-align: center;
}

/* Number text (1/3 etc) */
.numbertext {
  color: #f2f2f2;
  font-size: 12px;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}

/* The dots/bullets/indicators */
.dot {
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.active, .dot:hover {
  background-color: #717171;
}

/* Fading animation */
.fade {
  -webkit-animation-name: fade;
  -webkit-animation-duration: 1.5s;
  animation-name: fade;
  animation-duration: 1.5s;
}

@-webkit-keyframes fade {
  from {opacity: .4}
  to {opacity: 1}
}

@keyframes fade {
  from {opacity: .4}
  to {opacity: 1}
}
</style>
